export const busstOptions = [
  { label: "开业", value: "1" },
  { label: "筹建", value: "2" },
  { label: "停业", value: "3" },
  { label: "歇业", value: "4" },
  { label: "清算", value: "5" },
  { label: "其他", value: "9" },
];

export const holdingsmsgOptions = [
  { label: "港澳台商控股", value: "4" },
  { label: "集体控股", value: "2" },
  { label: "国有控股", value: "1" },
  { label: "外商控股", value: "5" },
  { label: "私人控股", value: "3" },
  { label: "其他", value: "9" },
];

export const subconformOptions = [
  { label: "实物", value: "2" },
  { label: "劳务", value: "8" },
  { label: "知识产权", value: "3" },
  { label: "土地使用权", value: "6" },
  { label: "货币", value: "1" },
  { label: "债权", value: "4" },
  { label: "股权", value: "7" },
  { label: "其他", value: "9" },
];

export const parinsOptions = [
  { label: "党支部", value: "3" },
  { label: "党委", value: "1" },
  { label: "未成立", value: "4" },
  { label: "党总支", value: "2" },
];

export const webtypeOptions = [
  { label: "网站", value: "1" },
  { label: "网店", value: "2" },
];

export const getLabel = (value, options) => {
  try {
    return options.find((item) => item.value == value).label;
  } catch (e) {}
};
